export default [
    {
        path: '/occupancy-alerts',
        name: 'occupancy-alerts',
        component: () => import('./pages/Index'),
        meta: {
            title: 'Alertas de Ocupação',
            icon: 'mdi-bell-alert',
            breadcrumbs: [
                { text: 'Alertas de Ocupação', disabled: true }
            ]
        }
    }
]
